import { gql } from 'apollo-angular';
import { HttpLogEntry } from '../../entities/httpLogEntry/httpLogEntry';
import { Page } from '../../entities/page/page';



export const HTTP_LOGS_QUERY = gql`
query httpLogsQuery($pageNumber: Int, $pageSize: Int, $sortProperty: String, $sortDirection: String, $text: String, $statusCode: Int)
{
  httpLogs: getHttpLogEntriesPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection},
      text: $text,
      statusCode: $statusCode
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
          method
          path
          statusCode
          statusPhrase
          startDateTime
          endDateTime
          duration
          apiKeyId
          requestBody
          responseBody
          traceId
          transactionId
          requestId
      }
    }
}
`;

export interface HttpLogsQueryResponse {
  loading: boolean;
  httpLogs:Page<HttpLogEntry>;
}
